/* eslint-disable no-nested-ternary */
import { alpha, Box, Typography } from '@mui/material';
import { COLOR_ACCENT, CratLogoAnimated, useBreakpoints } from 'shared';
import { COLOR_BG, COLOR_STROKE, TRANSITION_300 } from 'shared/config';

const LOGO_CIRCLE_DIAMETER_LG = 240;
const LOGO_CIRCLE_DIAMETER_MD = 140;
const LOGO_CIRCLE_DIAMETER_SM = 190;

interface LogoProps {
  onClick: () => void;
}

export const Logo = ({ onClick }: LogoProps) => {
  const { isDownMdLayout, isDownSmLayout } = useBreakpoints();

  const logoCircleDiameter = isDownSmLayout
    ? LOGO_CIRCLE_DIAMETER_SM
    : isDownMdLayout
    ? LOGO_CIRCLE_DIAMETER_MD
    : LOGO_CIRCLE_DIAMETER_LG;

  return (
    <Box
      sx={{
        position: 'relative',
        width: logoCircleDiameter,
        height: logoCircleDiameter,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        onClick={onClick}
        sx={{
          position: 'relative',
          cursor: 'pointer',
          transition: TRANSITION_300,
          width: '100%',
          height: '100%',
          borderRadius: '50%',
          background: COLOR_BG,
          border: '1px solid',
          borderColor: COLOR_STROKE,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          zIndex: 1,
          '&:hover': {
            transform: 'scale(1.25)',
          },
        }}
      >
        <Box
          component="img"
          src={CratLogoAnimated}
          sx={{
            width: { md: 67, xs: 46 },
          }}
        />
        <Typography mt={0.5} fontSize={{ sm: 12, md: 16 }} fontWeight="bold" textAlign="center">
          Layer-1 Blockchain
          <br />
          (DPoS)
        </Typography>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          width: '120%',
          height: '120%',
          top: '50%',
          left: '50%',
          borderRadius: '50%',
          background: alpha(COLOR_ACCENT, 0.23),
          filter: 'blur(71px)',
          transform: 'translate(-50%, -50%)',
        }}
      />
    </Box>
  );
};
